import { render, staticRenderFns } from "./ConsumedCashbackMetrics.vue?vue&type=template&id=587e3d2d&scoped=true"
import script from "./ConsumedCashbackMetrics.vue?vue&type=script&lang=js"
export * from "./ConsumedCashbackMetrics.vue?vue&type=script&lang=js"
import style0 from "./ConsumedCashbackMetrics.vue?vue&type=style&index=0&id=587e3d2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587e3d2d",
  null
  
)

export default component.exports